import { Grid, LEGOLogo, Navbar, Text } from '@lego/klik-ui';
import { useState } from 'react';
import { Link as ReactRouterLink } from 'react-router-dom';
import { DesktopNavigationBar } from '@/components/common/navbar/DesktopNavigationBar';
import { MobileNavigationBar } from '@/components/common/navbar/MobileNavigationBar';
import { useUserStore } from '@/stores/user_store';
import { emmaDocsURL } from '@/utility/external_urls';
import { paths } from '@/utility/global_paths';

const navItems = [
  { path: paths.workspaces, label: 'Workspaces', adminOnly: false },
  { path: paths.devices, label: 'Devices', adminOnly: false },
  { path: paths.deviceActions, label: 'Scan Device', adminOnly: false },
] as const;

const navEmmaItems = [
  { path: paths.deviceTypes, label: 'Device Types', adminOnly: false },
  { path: paths.osDownloads, label: 'OS Downloads', adminOnly: false },
  { path: paths.store, label: 'Store', adminOnly: false },
  { path: emmaDocsURL, label: 'Documentation', adminOnly: false, isExternal: true },
  { path: import.meta.env.VITE_ELASTIC_URL, label: 'Logs', adminOnly: false, isExternal: true },
  { path: paths.kpis, label: 'KPIs', adminOnly: true },
] as const;

export const NavigationBar = () => {
  const isAdmin = useUserStore((s) => s.isAdmin);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const toggleMenu = () => setIsOpen((prev) => !prev);

  return (
    <Grid.Item as="header" gridArea="mainNavbar" width="100%">
      <Navbar width="full">
        <Navbar.Brand as={ReactRouterLink} cursor="pointer" to={paths.home}>
          <LEGOLogo mr={5} />
          <Text fontSize="lg">EMMA</Text>
        </Navbar.Brand>

        <DesktopNavigationBar
          isOpen={isOpen}
          navEmmaItems={navEmmaItems.filter((navItem) => isAdmin || !navItem.adminOnly)}
          navItems={navItems.filter((navItem) => isAdmin || !navItem.adminOnly)}
          toggleMenu={toggleMenu}
        />
        <MobileNavigationBar
          isOpen={isOpen}
          navEmmaItems={navEmmaItems.filter((navItem) => isAdmin || !navItem.adminOnly)}
          navItems={navItems.filter((navItem) => isAdmin || !navItem.adminOnly)}
          toggleMenu={toggleMenu}
        />
      </Navbar>
    </Grid.Item>
  );
};
